import * as React from 'react';
import { MenuItem as MuiMenuItem, MenuItemProps as MuiMenuItemProps } from '@mui/material';

type MenuItemProps = Omit<MuiMenuItemProps, 'button'>;

const MenuItem: React.FC<MenuItemProps> = (props: MenuItemProps = {}) => <MuiMenuItem {...props} />;

export type { MenuItemProps };
export default MenuItem;
